import { useCallback, useMemo, useState } from 'react'
import map from 'lodash/map'
import ClassNames from 'classnames'
import { useFormikContext } from 'formik'

import { CryptoPaymentInput } from '../CryptoPaymentFormElements/CryptoPaymentInput'
import { CryptoPaymentDropdownItem } from './CryptoPaymentDropdownItem'
import { inputActionType } from '../CryptoPaymentFormElements/cryptoPaymentInputConstants'

import classes from './styles/cryptoPaymentDropdown.module.scss'

export const CryptoPaymentDropdown = ({
  name,
  items,
  label,
  onChange,
  disabled,
  className,
  inputName,
  inputType,
  inputFormat,
  onInputChange,
  inputDisabled,
  inputPlaceholder
}) => {
  const [open, setOpen] = useState(false)
  const { setFieldValue, values, errors, touched } = useFormikContext()

  const componentDropdownClassName = ClassNames(classes.cryptoPaymentDropdown, {
    [classes.cryptoPaymentDropdown_disabled]: disabled
  })

  const componentDropdownPreviewClassName = ClassNames(classes.cryptoPaymentDropdown__previewItem, {
    [classes.cryptoPaymentDropdown__previewItem_withInput]: inputName,
    [classes.cryptoPaymentDropdown__previewItem_open]: open
  })

  const componentDropdownInputCopyClassName = ClassNames({
    [classes.cryptoPaymentDropdown__input_open]: open
  })

  const componentContainerClassName = ClassNames(classes.cryptoPaymentDropdown__itemsContainer, {
    [classes.cryptoPaymentDropdown__itemsContainer_open]: open
  })

  const componentArrowClassName = ClassNames(classes.cryptoPaymentDropdown__arrow, {
    [classes.cryptoPaymentDropdown__arrow_open]: open,
    [classes.cryptoPaymentDropdown__arrow_withInput]: inputName
  })

  const selectedCryptoItem = useMemo(() => items && items.find(item => item.currencyCode === values[name]), [
    items,
    name,
    values
  ])

  const handleItemChange = useCallback(
    currency => {
      onChange && onChange(currency)
      setFieldValue && setFieldValue(name, currency.currencyCode)
      setOpen(false)
    },
    [onChange, setFieldValue, name]
  )

  const getInputLabel = useCallback(() => {
    if (typeof label === 'string' || typeof label === 'number') {
      return label
    }

    if (typeof label === 'function') {
      return label()
    }

    return ''
  }, [label])

  return (
    <div className={className}>
      {label && <label className={classes.cryptoPaymentDropdown__label}>{getInputLabel()}</label>}
      <div className={componentDropdownClassName}>
        <div
          className={componentDropdownPreviewClassName}
          onClick={() => {
            if (!disabled) {
              setOpen(!open)
            }
          }}
        >
          {selectedCryptoItem && (
            <>
              <img
                className={classes.cryptoPaymentDropdown__previewItemIcon}
                src={`${
                  process.env.PUBLIC_URL
                }/content/images/icons/crypto-icon-${selectedCryptoItem.currencyCode.toLowerCase()}.png`}
                alt={selectedCryptoItem.currencyName}
              />
              <span className={classes.cryptoPaymentDropdown__currencyCode}>{selectedCryptoItem.currencyCode}</span>
            </>
          )}
          <div className={componentArrowClassName} />
        </div>
        {inputName && (
          <CryptoPaymentInput
            isCombined
            name={inputName}
            type={inputType}
            formElement={false}
            format={inputFormat}
            onChange={onInputChange}
            disabled={inputDisabled}
            placeholder={inputPlaceholder}
            actionType={inputActionType.copy}
            className={classes.cryptoPaymentDropdown__inputComponent}
            inputClassName={classes.cryptoPaymentDropdown__input}
            copyButtonClassName={componentDropdownInputCopyClassName}
          />
        )}
        {items.length !== 0 && (
          <div className={componentContainerClassName}>
            {map(items, currency => (
              <CryptoPaymentDropdownItem
                setOpen={onChange}
                currency={currency}
                key={currency.currencyCode}
                onChange={handleItemChange}
                selectedCryptoItem={selectedCryptoItem}
              />
            ))}
          </div>
        )}
      </div>
      {errors[name] && touched[name] && <div className={classes.cryptoPaymentDropdown__inputError}>{errors[name]}</div>}
    </div>
  )
}
